/*eslint-disable no-undef*/
var isInTest = typeof global.it === 'function';

var AGENT_VERSION_VAR = "";

if (!isInTest) {
    AGENT_VERSION_VAR = `${SDK_VERSION}`;
}

export const AGENT_VERSION = AGENT_VERSION_VAR;


// WEBPACK FOOTER //
// ./js/core/Constants.js